/**
 * Dev-only logger utility.
 * Logs are stripped in production builds via dead-code elimination
 * since the condition `process.env.NODE_ENV === 'development'` is
 * statically replaced at build time.
 */
/* eslint-disable no-console -- dev-only logger intentionally uses console methods */
const isDev = process.env.NODE_ENV === 'development';

const createLogger = (method, prefix) => (message, ...args) => {
  if (isDev) {
    console[method](`${prefix} ${message}`, ...args);
  }
};

const devLog = {
  error: createLogger('error', '[DEV ERROR]'),
  warn: createLogger('warn', '[DEV WARN]'),
  info: createLogger('log', '[DEV INFO]'),
};
/* eslint-enable no-console */

export default devLog;
